import "./index.less";
import {  useEffect, useState } from "react";
import { GlobalSensor, GlobalSensorParameter } from "@/commons/interface/maint/lib-device/global-sensor";
import { getGlobalSensorDetail, updateGlobalSensorParameter } from "@/api/maint/lib/lib-sensor";
import { Skeleton, Table } from "antd";
import { getSensorTypeName } from "@/commons/enums/sensor-type";
import { getSignalTypeName } from "@/commons/enums/signal-type";
import { getVerifyTypeName } from "@/commons/enums/verify-type";
// import { InlineMath, BlockMath } from 'react-katex';
// import 'katex/dist/katex.min.css';
// import MonacoEditor from '@monaco-editor/react';
import { EditableCell, EditableRow } from "tncet-common";
import { MONITOR_PARAMETER_TYPE_LIST, getMonitorParameterTypeName } from "@/commons/enums/monitor-parameter-type";
import { ReactComponent as AddSvg } from '@/commons/icons/desktop-lib/param-add.svg';
import { ReactComponent as EditSvg } from '@/commons/icons/desktop-lib/edit.svg';
import AddDeviceFunctionModal from "./func-add";
import EditDeviceFunctionModal from "./func-edit";
import TnMessage from "@/commons/widget/message";

interface IProps {
    sensorId: number
    needRender: boolean
}

export default function LibSensorPanel(props: IProps) {
    const [globalSensor, setGlobalSensor] = useState<GlobalSensor>(null); // 传感器
    const [loading, setLoading] = useState<boolean>(false); // loading
    const [cellSelected, setCellSelected] = useState<string>();
    const [addVisible, setAddVisible] = useState<boolean>(false); // 添加弹窗
    const [editVisible, setEditVisible] = useState<boolean>(false); // 编辑弹窗

    // 初始化
    useEffect(() => {
        if (!props?.sensorId) return;
        generateData();
    }, [props?.sensorId, props?.needRender])

    const generateData = () => {
        setLoading(true)
        getGlobalSensorDetail(+props?.sensorId).then(res => {
            let data: GlobalSensor = res.data || null;
            setGlobalSensor(data);
        }).finally(() => {
            setLoading(false);
        })
    }

    const handleSave = (newRow: GlobalSensorParameter, field) => {
        updateGlobalSensorParameter(newRow.id, newRow).then(res => {
            if (res.status === 200) {
                TnMessage.success("编辑成功");
                let idx = globalSensor?.globalSensorParameters?.findIndex(item => item.id === newRow.id);
                let newPars = [...globalSensor?.globalSensorParameters];
                newPars[idx] = newRow;
                setGlobalSensor(pre => {
                    pre.globalSensorParameters = newPars;
                    return { ...pre };
                })
            }
        }).catch(err => {
            TnMessage.error("编辑失败");
        })
    }

    return (
        <div className="lib-sensor-container">
            <Skeleton loading={loading}>
                <div className="title">
                    {getSensorTypeName(globalSensor?.type) || '传感器'}
                </div>
                <div className="main">

                    <div className="item">
                        <div className="item-name">型号</div>
                        <div className="item-value-list">
                            <div className="value-item">
                                {globalSensor?.marking || ''}
                            </div>
                        </div>
                    </div>
                    <div className="item">
                        <div className="item-name">厂商</div>
                        <div className="item-value-list">
                            <div className="value-item">
                                {globalSensor?.manufacturer || ''}
                            </div>
                        </div>
                    </div>
                    <div className="item">
                        <div className="item-name">精度</div>
                        <div className="item-value-list">
                            <div className="value-item">
                                {globalSensor?.precision || ''}
                            </div>
                        </div>
                    </div>
                    <div className="item">
                        <div className="item-name">量程</div>
                        <div className="item-value-list">
                            <div className="value-item">
                                {globalSensor?.range || ''}
                            </div>
                        </div>
                    </div>
                    <div className="item">
                        <div className="item-name">英文名称</div>
                        <div className="item-value-list">
                            <div className="value-item">
                                {globalSensor?.englishName || ''}
                            </div>
                        </div>
                    </div>
                    <div className="item">
                        <div className="item-name">信号类型</div>
                        <div className="item-value-list">
                            <div className="value-item">
                                {getSignalTypeName(globalSensor?.signalType) || ''}
                            </div>
                        </div>
                    </div>
                    <div className="item">
                        <div className="item-name">信号类型</div>
                        <div className="item-value-list">
                            <div className="value-item">
                                {getVerifyTypeName(globalSensor?.verifyType) || ''}
                            </div>
                        </div>
                    </div>
                    <div className="item">
                        <div className="item-name">计算公式</div>
                        <div className="item-value-list">
                            <div className="value-item">
                                {/* <InlineMath math={globalSensor?.formulaStr || ''} /> */}
                            </div>
                        </div>
                    </div>
                    <div className="item">
                        <div className="item-name">
                            {!globalSensor?.receiveFunc && <AddSvg onClick={() => setAddVisible(true)} />}
                            {globalSensor?.receiveFunc && <EditSvg onClick={() => setEditVisible(true)} />}
                            计算方法
                        </div>
                        <div className="item-value-list">
                            {/* <MonacoEditor
                                height="158px"
                                defaultLanguage="python"
                                value={globalSensor?.functionContent || ''}
                                theme="vs-dark"
                                options={{
                                    minimap: { enabled: false },
                                    lineNumbers: "on",
                                    readOnly: true,
                                }}
                            /> */}
                        </div>
                    </div>
                    <div className="item">
                        <div className="item-name">监测参数</div>
                        <div className="item-value-list">
                            <Table
                                rowKey="id"
                                pagination={false}
                                dataSource={globalSensor?.globalSensorParameters || []}
                                bordered={false}
                                className='tn-project-table'
                                sticky
                                rowClassName="user-table-row"
                                components={{
                                    body: {
                                        row: EditableRow,
                                        cell: EditableCell,
                                    }
                                }}
                                loading={loading}
                            >
                                <Table.Column dataIndex="globalMonitorParameterName" title="监测参数" ellipsis />
                                <Table.Column dataIndex="level" title="类型"
                                    render={(value: number, row: GlobalSensorParameter) => {
                                        return getMonitorParameterTypeName(value) || ''
                                    }}
                                    onCell={(record: GlobalSensorParameter, idx) => {

                                        return {
                                            record,
                                            editable: true,
                                            dataIndex: 'level',
                                            directEdit: true,
                                            title: '',
                                            type: 'Select',
                                            showSelectSearch: true,
                                            cellKey: `${record.id}-level`,
                                            selectedKey: cellSelected,
                                            options: MONITOR_PARAMETER_TYPE_LIST,
                                            onTap: (_, key) => { },
                                            handleSave: (e) => handleSave(e, 'level'),
                                        }
                                    }}
                                />
                                <Table.Column dataIndex="idx" title="索引"
                                    onCell={(record: GlobalSensorParameter, idx) => {
                                        return {
                                            record,
                                            editable: true,
                                            dataIndex: 'idx',
                                            directEdit: true,
                                            title: '',
                                            cellKey: `${record.id}-idx`,
                                            selectedKey: cellSelected,
                                            onTap: (_, key) => { },
                                            handleSave: (e) => handleSave(e, 'idx'),
                                        }
                                    }}
                                />
                            </Table>
                        </div>
                    </div>
                </div>
            </Skeleton>

            {addVisible && <AddDeviceFunctionModal
                visible={addVisible}
                setVisible={setAddVisible}
                onSuccess={() => {
                    generateData();
                    setAddVisible(false);
                }}
                sensorId={props.sensorId}
            />}

            {editVisible && <EditDeviceFunctionModal
                visible={editVisible}
                setVisible={setEditVisible}
                onSuccess={() => {
                    generateData();
                    setEditVisible(false);
                }}
                sensor={globalSensor}
            />}
        </div>
    )
}